import React, { useEffect, useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import axios from 'axios';
import toast from 'react-hot-toast';
import { handleUnauthorized } from '../../../TokenAuth/auth';

function RecommendedFreeChat() {
    const [formData, setFormData] = useState({
        recommendedFreeChat: {
            title: '',
            subTitle: ''
        },
        recommendedUsed: {
            title: '',
            subTitle: ''
        }
    });
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState({
        recommendedFreeChat: false,
        recommendedUsed: false
    });

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem("astroVani-admin-token");

            // Fetch all data in a single request
            const response = await axios.get(
                `${process.env.REACT_APP_BASEURL}/admin/recommendedFreeChat`,
                {
                    headers: {
                        'Authorization': `${token}`,
                        'Content-Type': 'application/json',
                    },
                }
            );

            if (response.data?.success && Array.isArray(response.data?.data)) {
                const dataArray = response.data.data;

                // Find and populate recommendedFreeChat
                const freeChatData = dataArray.find(item => item.key === 'recommendedFreeChat');
                if (freeChatData) {
                    setFormData(prev => ({
                        ...prev,
                        recommendedFreeChat: {
                            title: freeChatData.title || '',
                            subTitle: freeChatData.subTitle || ''
                        }
                    }));
                }

                // Find and populate recommendedUsed
                const usedData = dataArray.find(item => item.key === 'recommendedUsed');
                if (usedData) {
                    setFormData(prev => ({
                        ...prev,
                        recommendedUsed: {
                            title: usedData.title || '',
                            subTitle: usedData.subTitle || ''
                        }
                    }));
                }
            }
        } catch (error) {
            if (error.response?.status === 401) {
                handleUnauthorized();
            } else {
                console.error('Error fetching data:', error);
                // Don't show error toast on initial load if no data exists
            }
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (key, field, value) => {
        setFormData(prev => ({
            ...prev,
            [key]: {
                ...prev[key],
                [field]: value
            }
        }));
    };

    const handleSave = async (key) => {
        try {
            setSaving(prev => ({ ...prev, [key]: true }));
            const token = localStorage.getItem("astroVani-admin-token");

            const payload = {
                key: key,
                title: formData[key].title,
                subTitle: formData[key].subTitle
            };

            const response = await axios.patch(
                `${process.env.REACT_APP_BASEURL}/admin/recommendedFreeChat`,
                payload,
                {
                    headers: {
                        'Authorization': `${token}`,
                        'Content-Type': 'application/json',
                    },
                }
            );

            if (response.data?.success) {
                toast.success(`${key === 'recommendedFreeChat' ? 'Recommended Free Chat' : 'Recommended Used'} saved successfully!`);
            } else {
                toast.error(response.data?.message || `Failed to save ${key}`);
            }
        } catch (error) {
            if (error.response?.status === 401) {
                handleUnauthorized();
            } else {
                console.error(`Error saving ${key}:`, error);
                toast.error(error.response?.data?.message || `Error saving ${key}`);
            }
        } finally {
            setSaving(prev => ({ ...prev, [key]: false }));
        }
    };

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                <CircularProgress />
            </div>
        );
    }

    return (
        <>
            {/* Header */}
            <div className="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
                <h4 className="mb-0 fw-bold">
                    Recommended Astrologer
                </h4>
            </div>

            <div className="card-body">
                <form>
                    <div className="row g-4">
                        {/* Recommended Free Chat Section */}
                        <div className="col-12">
                            <div className="card" style={{ border: '1px solid #e0e0e0', borderRadius: '12px' }}>
                                <div className="card-header bg-transparent border-bottom">
                                    <h5 className="mb-0 fw-bold">Free Chat</h5>
                                </div>
                                <div className="card-body">
                                    <div className="row g-3">
                                        <div className="col-md-12">
                                            <label className="form-label fw-bold">
                                                Title <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter title"
                                                value={formData.recommendedFreeChat.title}
                                                onChange={(e) => handleInputChange('recommendedFreeChat', 'title', e.target.value)}
                                            />
                                        </div>
                                        <div className="col-md-12">
                                            <label className="form-label fw-bold">
                                                Sub Title <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <textarea
                                                className="form-control"
                                                rows="3"
                                                placeholder="Enter subtitle"
                                                value={formData.recommendedFreeChat.subTitle}
                                                onChange={(e) => handleInputChange('recommendedFreeChat', 'subTitle', e.target.value)}
                                            />
                                        </div>
                                        <div className="col-12">
                                            <Button
                                                variant="contained"
                                                onClick={() => handleSave('recommendedFreeChat')}
                                                disabled={saving.recommendedFreeChat || !formData.recommendedFreeChat.title || !formData.recommendedFreeChat.subTitle}
                                                sx={{
                                                    borderRadius: '8px',
                                                    textTransform: 'none',
                                                    px: 4,
                                                    py: 1.5,
                                                    fontSize: '14px',
                                                    fontWeight: 600,
                                                    backgroundColor: 'var(--primary-color, #E7B242)',
                                                    color: '#ffffff',
                                                    boxShadow: 'none',
                                                    '&:hover': {
                                                        backgroundColor: 'var(--primary-color, #E7B242)',
                                                        boxShadow: 'none',
                                                        opacity: 0.9,
                                                    },
                                                    '&:disabled': {
                                                        backgroundColor: 'rgba(0, 0, 0, 0.12)',
                                                        color: 'rgba(0, 0, 0, 0.26)',
                                                    }
                                                }}
                                            >
                                                {saving.recommendedFreeChat ? "Saving..." : "Save Free Chat"}
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Recommended Used Section */}
                        <div className="col-12">
                            <div className="card" style={{ border: '1px solid #e0e0e0', borderRadius: '12px' }}>
                                <div className="card-header bg-transparent border-bottom">
                                    <h5 className="mb-0 fw-bold">Free Chat Used</h5>
                                </div>
                                <div className="card-body">
                                    <div className="row g-3">
                                        <div className="col-md-12">
                                            <label className="form-label fw-bold">
                                                Title <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter title"
                                                value={formData.recommendedUsed.title}
                                                onChange={(e) => handleInputChange('recommendedUsed', 'title', e.target.value)}
                                            />
                                        </div>
                                        <div className="col-md-12">
                                            <label className="form-label fw-bold">
                                                Sub Title <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <textarea
                                                className="form-control"
                                                rows="3"
                                                placeholder="Enter subtitle"
                                                value={formData.recommendedUsed.subTitle}
                                                onChange={(e) => handleInputChange('recommendedUsed', 'subTitle', e.target.value)}
                                            />
                                        </div>
                                        <div className="col-12">
                                            <Button
                                                variant="contained"
                                                onClick={() => handleSave('recommendedUsed')}
                                                disabled={saving.recommendedUsed || !formData.recommendedUsed.title || !formData.recommendedUsed.subTitle}
                                                sx={{
                                                    borderRadius: '8px',
                                                    textTransform: 'none',
                                                    px: 4,
                                                    py: 1.5,
                                                    fontSize: '14px',
                                                    fontWeight: 600,
                                                    backgroundColor: 'var(--primary-color, #E7B242)',
                                                    color: '#ffffff',
                                                    boxShadow: 'none',
                                                    '&:hover': {
                                                        backgroundColor: 'var(--primary-color, #E7B242)',
                                                        boxShadow: 'none',
                                                        opacity: 0.9,
                                                    },
                                                    '&:disabled': {
                                                        backgroundColor: 'rgba(0, 0, 0, 0.12)',
                                                        color: 'rgba(0, 0, 0, 0.26)',
                                                    }
                                                }}
                                            >
                                                {saving.recommendedUsed ? "Saving..." : "Save Free Chat Used"}
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
}

export default RecommendedFreeChat;

